import React from "react";
import "./CMSectionAbout.css";
import MainImg from "../../assets/cm-about-main.png";

export default function SectionAbout() {
  return (
    <section className="abt-wrapper-cmabout">
  <div className="abt-container-cmabout">

    {/* LEFT SIDE CONTENT */}
    <div className="abt-left-cmabout">
      <span className="abt-tag-cmabout">ABOUT CM GROUP</span>

      <h2 className="abt-title-cmabout">
        Integrated Vision.<br />
        Sustainable Growth.<br />
        Solutions That Transform.
      </h2>

      <p className="abt-desc-cmabout">
        Since 2019, CM Group integrates land development and energy solutions, delivering 600 acres and a 150 MW solar plant to drive sustainable, long-term infrastructure growth.
      </p>
    </div>

    {/* RIGHT SIDE IMAGES */}
    <div className="abt-right-cmabout">
      <img src={MainImg} alt="Main Facility" className="abt-main-cmabout-img" />
    </div>

  </div>
</section>

  );
}
